import { render, staticRenderFns } from "./store-layout.vue?vue&type=template&id=16d6fba0&scoped=true"
import script from "./store-layout.vue?vue&type=script&lang=js"
export * from "./store-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6fba0",
  null
  
)

export default component.exports